import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const Orders = ({ cartItems, setCartItems }) => {
  const handleRemove = (id) => {
    const updatedCart = cartItems.filter((item) => item.id !== id);
    setCartItems(updatedCart);
    localStorage.setItem('cart', JSON.stringify(updatedCart));
  };

  return (
    <Box>
      {cartItems.map((item, index) => (
        <Box key={index} display="flex" marginBottom={2}>
          <img
            src={item.product.image || 'default-image.jpg'}
            alt={item.product.productName}
            style={{ width: 100, height: 100, marginRight: 16 }}
          />
          <Box flex={1}>
            <Typography variant="h6" fontWeight={700}>
              {item.product.productName}
            </Typography>
            <Typography color="text.secondary">
              {item.product.description}
            </Typography>
            <Typography color="text.secondary">
              Price: £{item.product.productCost}
            </Typography>
            <Button color="error" onClick={() => handleRemove(item.id)}>
              Remove
            </Button>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default Orders;
